import { authService, AUTH_CHANGED_EVENT } from './AuthService';
import { eventBus } from '../events/EventBus';
import { i18nService, LANGUAGE_CHANGED_EVENT } from '../i18n/I18nService';
// Fixed top-right button next to the language switcher: "Profile" once signed
// in, "Login" otherwise. Mirrors LanguageSwitcher.ts's pattern of a single
// element mounted once on document.body (outside the DSL-rendered #app root),
// but its label depends on both auth state and locale, so it re-renders on
// both AUTH_CHANGED_EVENT and LANGUAGE_CHANGED_EVENT instead of just once.
export function createProfileButton() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'profile-button';
    function render() {
        button.textContent = authService.isAuthorized
            ? i18nService.t('header.profileButton')
            : i18nService.t('header.loginButton');
    }
    button.addEventListener('click', () => {
        window.location.hash = authService.isAuthorized ? '#page=profile' : '#page=auth';
    });
    eventBus.on(AUTH_CHANGED_EVENT, render);
    eventBus.on(LANGUAGE_CHANGED_EVENT, render);
    render();
    return button;
}
